import { render, staticRenderFns } from "./IndexCouponsPage.vue?vue&type=template&id=63edeeab&"
import script from "./IndexCouponsPage.vue?vue&type=script&lang=js&"
export * from "./IndexCouponsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports